import { ProfileSectionProps } from "./types";
import { useTranslation } from "react-i18next";
import { FormSection } from "@/features/common/components/FormSection";
import { AddressFields } from "./Address/AddressFields";

export function AddressSection({
  profile,
  setProfile,
  loading,
  readOnly
}: ProfileSectionProps) {
  const { t } = useTranslation("talent");
  return (
    <FormSection title={t("forms.sections.address.title")}>
      <AddressFields
        profile={profile}
        setProfile={setProfile}
        loading={loading}
        readOnly={readOnly}
      />
    </FormSection>
  );
}
